<!-- @format -->

<template>
  <div class="ui sixteen column grid centered">
    <div class="sixteen wide column" style="padding: 1em 0em 0em 2em">
      <div class="ui form">
        <div class="ui field">
          <label>
            Description
          </label>
          <input type="text" v-model="assumptions.result.description" />
        </div>
        <div class="ui small field">
          <label>
            Long-term inflation rate
            <small
              >{{ formatNr(assumptions.result.expectedInflationRate) }}
            </small></label
          >
          <input
            v-if="edit"
            small
            style="font-size: small"
            type="number"
            v-model="assumptions.result.expectedInflationRate"
          /><span v-else>
            {{ formatNr(Number(assumptions.result.expectedInflationRate)) }}
          </span>
        </div>

        <table class="ui table" style="font-size: small">
          <thead>
            <tr>
              <th>Description</th>
              <th>Exp return (%)</th>
              <th>Exp annualised vol (%)</th>
            </tr>
          </thead>

          <tr
            v-for="(a, index) in take(
              skip(assumptions.arrayFormat, pageNr * 10),
              10
            )"
          >
            <td>{{ a.name }}</td>
            <td>
              <input
                small
                style="font-size: small"
                v-if="edit"
                type="number"
                v-model="a.expectedNominalReturn"
              /><span v-else>
                Nominal:
                {{
                  formatNr(
                    Number(a.expectedNominalReturn) +
                      Number(assumptions.result.expectedInflationRate)
                  )
                }}
                Real: {{ formatNr(Number(a.expectedNominalReturn)) }}</span
              >
              {{ a.edit }}
            </td>
            <td>
              {{ formatNr(a.standardDeviation) }}
            </td>
          </tr>
          <tfoot v-if="assumptions.arrayFormat.length > 10">
            <th colspan="3" style="text-align: right">
              <a
                class="ui tiny button"
                v-if="assumptions.arrayFormat.length > 10 && pageNr >= 1"
                href="#"
                @click.prevent="pageNr--"
                >Previous Page
              </a>
              <a
                class="ui tiny button"
                v-if="assumptions.arrayFormat.length > (pageNr + 1) * 10"
                href="#"
                @click.prevent="pageNr++"
                >Next Page
              </a>
            </th>
          </tfoot>
        </table>

        <div class="ui divider"></div>
        <div class="ui segment" v-if="message == ''">
          <a
            href="#"
            class="ui button"
            v-if="!edit"
            @click.prevent="editNumbers"
            >Edit Real Returns</a
          >

          <a href="#" class="ui button" v-if="edit" @click.prevent="save"
            >Save</a
          >
          <a href="#" class="ui button" v-if="edit" @click.prevent="cancel"
            >Cancel</a
          >
        </div>
        <div class="ui segment" v-else>
          {{ message }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updatePartnerCapitalMarketAssumptions } from "@/gateway.js";
import * as _ from "lodash";
import numeral from "numeral";
import vSelect from "vue-select";

export default {
  name: "home",
  components: { vSelect },
  computed: {},
  props: ["aaType", "assumptions"],
  data() {
    return {
      edit: false,
      pageNr: 0,
      originalAssumptions: null,
      originalInflation: null,
      message: "",
    };
  },

  methods: {
    editNumbers() {
      this.originalAssumptions = JSON.parse(
        JSON.stringify(this.assumptions.arrayFormat)
      );
      this.originalInflation = JSON.parse(
        JSON.stringify(this.assumptions.result.expectedInflationRate)
      );
      this.edit = true;
    },
    async save() {
      var response = await updatePartnerCapitalMarketAssumptions({
        id: this.assumptions.result.id,
        description: this.assumptions.result.description,
        expectedInflationRate: this.assumptions.result.expectedInflationRate,
        arrayFormat: this.assumptions.arrayFormat,
      });
      if (response) {
        this.edit = false;
        this.message = "Saved";
      }
    },
    cancel() {
      this.assumptions.arrayFormat = this.originalAssumptions;
      this.assumptions.result.expectedInflationRate = this.originalInflation;
      this.edit = false;
    },
    editindex(index) {
      this.assumptions.arrayFormat[index]["edit"] = true;
    },
    take: function(arr, size) {
      return _.take(arr, size);
    },
    skip: function(arr, size) {
      return _.drop(arr, size);
    },
    order: function(arr, val1, value2) {
      return _.orderBy(arr, [val1], [value2]);
    },
    formatNr(val) {
      return numeral(val).format("0,0.00%");
    },
  },
  mounted() {},
};
</script>
